module.exports = __webpack_public_path__ + "media/images/games/fifa-23/hiw-1-98450b617e0781f6c0bc672e2fadc5e9.jpg";